__turbopack_context__.v({
  "darkTheme": "recirculation-module-scss-module__DgdH7W__darkTheme",
  "recirculation": "recirculation-module-scss-module__DgdH7W__recirculation",
});
